import { render, staticRenderFns } from "./orders-summary-card.vue?vue&type=template&id=b3810474&"
import script from "./orders-summary-card.vue?vue&type=script&lang=js&"
export * from "./orders-summary-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports